module.exports = __webpack_public_path__ + "7cf2b524a5cfc20a7a5a6823d122b9cc.jpg";